// extracted by mini-css-extract-plugin
export default {"link":"_94259c17"};